import { Component, Input, OnInit, OnChanges, ViewChildren, QueryList } from '@angular/core';
import { MonitorService } from 'src/app/shared/services/monitor.service';
import { forkJoin } from 'rxjs';
import { buildPieV2, PieItem } from 'src/app/shared/helper/pie-utils.service';
import { PieGraphComponent } from 'src/app/shared/components/graph/pie-graph/pie-graph.component';

@Component({
  selector: 'app-device-xdr-monitorflow',
  templateUrl: './device-xdr-monitorflow.component.html',
  styleUrls: ['./device-xdr-monitorflow.component.scss']
})
export class DeviceXdrMonitorFlowComponent implements OnInit {

  @Input() deviceId: any;

  payloadFromApi: any = null;

  pieService: PieItem[] = [];
  pieDomain: PieItem[] = [];
  pieIface: PieItem[] = [];
  pieSrcIp: PieItem[] = [];
  pieDstIp: PieItem[] = [];

  @ViewChildren(PieGraphComponent) pieCharts!: QueryList<PieGraphComponent>;

  constructor(private api: MonitorService) {}

  ngOnInit(): void {
    this.loadRange("1h");
  }

  /** Handle tab changes */
  selectedTabChange(event: any) {
    const ranges = ["1h", "4h", "24h", "7d", "thisMonth", "lastMonth"];
    this.loadRange(ranges[event.index]);
  }

  /** Call API */
  loadRange(range: string) {
    forkJoin({
      service: this.api.getTraffic(this.deviceId, range, "service"),
      iface: this.api.getTraffic(this.deviceId, range, "iface"),
      dstIp: this.api.getTraffic(this.deviceId, range, "dst_ip"),
      srcIp: this.api.getTraffic(this.deviceId, range, "src_ip"),
      domain: this.api.getTraffic(this.deviceId, range, "domain")
    }).subscribe(res => {
      this.payloadFromApi = res;
      this.buildCharts();
    });
  }

  /** Convert API → Chart data */
  buildCharts() {
    const rows = this.payloadFromApi;

    this.pieService = buildPieV2(rows.service || []);
    this.pieDomain  = buildPieV2(rows.domain || []);
    this.pieIface   = buildPieV2(rows.iface || []);
    this.pieSrcIp   = buildPieV2(rows.srcIp || []);
    this.pieDstIp   = buildPieV2(rows.dstIp || []);

    // REDRAW canvas pies once DOM updated
    setTimeout(() => {
      this.pieCharts.forEach(c => c.redraw());
    }, 20);
  }
}
